export default __webpack_public_path__ + "static/media/TimeLapse2021_3.6a048bad.mp4";